function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11V7C16 4.8578 14.316 3.10892 12.1996 3.0049L12 3C9.8578 3 8.10892 4.68397 8.0049 6.80036L8 7V11H16ZM18 13H6V21H18V13ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM6 7C6 3.68629 8.68629 1 12 1C15.2384 1 17.8776 3.56557 17.9959 6.77506L18 7V11L18.1493 11.0055C19.1841 11.0818 20 11.9456 20 13V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V13C4 11.8954 4.89543 11 6 11V7Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BlackHorseIcon = function BlackHorseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 24C4.24286 24 3.83929 23.8321 3.50357 23.4964C3.16786 23.1607 3 22.7571 3 22.2857V9.88571C3 9.41429 3.16786 9.01071 3.50357 8.675C3.83929 8.33929 4.24286 8.17143 4.71429 8.17143H6.71429V5.42857C6.71429 3.92667 7.24387 2.64643 8.30303 1.58786C9.36219 0.529286 10.6431 0 12.1459 0C13.6486 0 14.9286 0.529286 15.9857 1.58786C17.0429 2.64643 17.5714 3.92667 17.5714 5.42857V8.17143H19.5714C20.0429 8.17143 20.4464 8.33929 20.7821 8.675C21.1179 9.01071 21.2857 9.41429 21.2857 9.88571V22.2857C21.2857 22.7571 21.1179 23.1607 20.7821 23.4964C20.4464 23.8321 20.0429 24 19.5714 24H4.71429ZM4.71429 22.2857H19.5714V9.88571H4.71429V22.2857ZM12.1477 18.2857C12.754 18.2857 13.2714 18.0759 13.7 17.6563C14.1286 17.2366 14.3429 16.7322 14.3429 16.1429C14.3429 15.5714 14.127 15.0524 13.6952 14.5857C13.2634 14.119 12.7444 13.8857 12.1381 13.8857C11.5317 13.8857 11.0143 14.119 10.5857 14.5857C10.1571 15.0524 9.94286 15.5762 9.94286 16.1571C9.94286 16.7381 10.1587 17.2381 10.5905 17.6571C11.0223 18.0762 11.5413 18.2857 12.1477 18.2857ZM8.42857 8.17143H15.8571V5.42857C15.8571 4.39682 15.4964 3.51984 14.7748 2.79763C14.0532 2.0754 13.177 1.71429 12.1462 1.71429C11.1154 1.71429 10.2381 2.0754 9.51429 2.79763C8.79048 3.51984 8.42857 4.39682 8.42857 5.42857V8.17143Z",
    fill: "currentColor"
  }));
};
BlackHorseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24V8.90498H5.85256V6.62443C5.85256 2.93213 8.90385 0 12.5 0C16.0962 0 19.1474 2.93213 19.1474 6.62443V8.90498H21V23.8914H4V24ZM13.6986 19.1131V16.3981C14.2435 15.9638 14.5704 15.4208 14.5704 14.6606C14.5704 13.466 13.5896 12.4886 12.3909 12.4886C11.1922 12.4886 10.2114 13.466 10.2114 14.6606C10.2114 15.4208 10.5383 16.0724 11.0832 16.3981V19.1131H13.6986ZM16.75 8.905V6.62445C16.75 4.23531 14.7885 2.38916 12.5 2.38916C10.1026 2.38916 8.25 4.23531 8.25 6.62445V8.905H16.75Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11V7C16 4.8578 14.316 3.10892 12.1996 3.0049L12 3C9.8578 3 8.10892 4.68397 8.0049 6.80036L8 7V11H16ZM18 13H6V21H18V13ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM6 7C6 3.68629 8.68629 1 12 1C15.2384 1 17.8776 3.56557 17.9959 6.77506L18 7V11L18.1493 11.0055C19.1841 11.0818 20 11.9456 20 13V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V13C4 11.8954 4.89543 11 6 11V7Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.01 10.98C19.35 10.76 18.68 10.56 18 10.39V8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8V10.39C5.32 10.56 4.65 10.76 3.99 10.98C3.39 11.18 3 11.76 3 12.39V20.5C3 21.33 3.67 22 4.5 22H19.5C20.33 22 21 21.33 21 20.5V12.39C21 11.76 20.61 11.18 20.01 10.98ZM7.3 8C7.3 5.41 9.41 3.29999 12 3.29999C14.59 3.29999 16.7 5.41 16.7 8V10.11C15.18 9.80999 13.61 9.64001 12 9.64001C10.39 9.64001 8.82 9.80999 7.3 10.11V8ZM19.7 20.5C19.7 20.61 19.61 20.7 19.5 20.7H4.5C4.39 20.7 4.3 20.61 4.3 20.5V12.39C4.3 12.31 4.35 12.23 4.41 12.21C6.88 11.37 9.43 10.94 12 10.94C14.57 10.94 17.12 11.37 19.59 12.21C19.65 12.23 19.7 12.31 19.7 12.39V20.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C11.64 13.25 11.35 13.54 11.35 13.9V18H12.65V13.9C12.65 13.54 12.36 13.25 12 13.25Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24V8.90498H5.85256V6.62443C5.85256 2.93213 8.90385 0 12.5 0C16.0962 0 19.1474 2.93213 19.1474 6.62443V8.90498H21V23.8914H4V24ZM13.6986 19.1131V16.3981C14.2435 15.9638 14.5704 15.4208 14.5704 14.6606C14.5704 13.466 13.5896 12.4886 12.3909 12.4886C11.1922 12.4886 10.2114 13.466 10.2114 14.6606C10.2114 15.4208 10.5383 16.0724 11.0832 16.3981V19.1131H13.6986ZM16.75 8.905V6.62445C16.75 4.23531 14.7885 2.38916 12.5 2.38916C10.1026 2.38916 8.25 4.23531 8.25 6.62445V8.905H16.75Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85718 12C2.85718 10.9088 3.62009 10.5 4.35361 10.5C4.99324 10.5 4.35361 10.5 5.10718 10.5C5.10718 9.18637 5.10718 7.26535 5.10718 6.375C5.10718 3.00893 8.48465 0 11.8572 0C15.2467 0 18.6072 3.00586 18.6072 6.375C18.6072 7.40339 18.6072 9.20343 18.6072 10.5C19.2642 10.5 18.6072 10.5 19.344 10.5C20.1383 10.5 20.8572 11.2974 20.8572 12C20.8572 12.439 20.8572 15.6179 20.8572 22.4821C20.8572 23.3117 20.1348 24 19.3572 24C18.8644 24 10.18 24 4.35361 24C3.61057 24 2.85718 23.2873 2.85718 22.4821C2.85718 21.6768 2.85718 13.0912 2.85718 12ZM7.35718 6.75C7.35718 8.12988 7.35718 9.37988 7.35718 10.5H16.3572C16.3572 9.42432 16.3572 8.17432 16.3572 6.75C16.3572 4.52628 14.1085 2.25 11.8572 2.25C9.6059 2.25 7.35718 4.16885 7.35718 6.75ZM10.3572 15.75C10.3572 16.2705 10.4615 16.5437 10.7322 16.875C11.1072 17.25 11.1072 18 11.1072 18.375C11.1072 18.8764 11.1072 19.1138 11.1072 19.5C11.1072 19.8862 11.4779 20.25 11.8572 20.25C12.2365 20.25 12.6072 19.8887 12.6072 19.5C12.6072 19.1113 12.6072 18.9343 12.6072 18.375C12.6072 17.8157 12.6072 17.25 12.9822 16.875C13.2721 16.5542 13.3572 16.3053 13.3572 15.75C13.3572 15.0098 12.6122 14.25 11.8572 14.25C11.1022 14.25 10.3572 15.014 10.3572 15.75Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.499 13C10.1192 13 9 14.1169 9 15.4958C8.99895 16.6628 9.80544 17.6409 10.8933 17.9123C11.0649 17.9781 11.2563 18 11.4362 18C11.796 18 12.1067 17.9123 12.1067 17.9123C13.1935 17.6409 14 16.6628 14 15.4958C14 14.1169 12.8808 13 11.499 13ZM11.499 14.5658C12.0126 14.5658 12.431 14.9833 12.431 15.4958C12.431 15.9207 12.1412 16.2891 11.6967 16.4008C11.6642 16.4092 11.5513 16.4321 11.41 16.4321H11.409L11.3682 16.4165L11.273 16.3925C10.8577 16.2891 10.568 15.9207 10.569 15.4958C10.569 14.9833 10.9864 14.5658 11.499 14.5658Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16 9.55229 15.5523 10 15 10C14.4477 10 14 9.55229 14 9V5.35018C14 4.06182 12.8906 3 11.4991 3C10.1088 3 9 4.06158 9 5.34933V9C9 9.55229 8.55228 10 8 10C7.44772 10 7 9.55229 7 9V5.34933C7 2.93709 9.02317 1 11.4991 1C13.976 1 16 2.93717 16 5.35018V9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5C10.5 16.9477 10.9477 16.5 11.5 16.5C12.0523 16.5 12.5 16.9477 12.5 17.5V19C12.5 19.5523 12.0523 20 11.5 20C10.9477 20 10.5 19.5523 10.5 19V17.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.4883C20 9.09926 18.8254 8 17.4094 8H5.59059C4.17461 8 3 9.09926 3 10.4883V21.5117C3 22.9007 4.17461 24 5.59059 24H17.4094C18.835 24 20 22.9036 20 21.5117V10.4883ZM5.59059 10H17.4094C17.7494 10 18 10.2346 18 10.4883V21.5117C18 21.771 17.7567 22 17.4094 22H5.59059C5.25063 22 5 21.7654 5 21.5117V10.4883C5 10.2346 5.25063 10 5.59059 10Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BLACK_HORSE, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT, BOS, HALIFAX, LLOYDS2023, MBNA, SCOTTISH_WIDOWS } from "../../constants";
export default function Padlock(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.padlock) {
    svg = theme.assets.icons.padlock;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BLACK_HORSE:
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = BlackHorseIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        console.warn("Icon \"Padlock\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}